(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-offer-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-offer-popup')) {
    customElements.define(
      'gift-offer-popup',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
          this.onePerVisit = this.dataset.repeatMode === 'session';
          this.handleSectionSelect = this.handleSectionSelect.bind(this);
          this.updateReadMore = this.updateReadMore.bind(this);

          this.querySelectorAll('[data-gift-offer-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => this.markSeen());

          this.querySelectorAll('.gift-offer-popup__read-more').forEach((button) => {
            button.addEventListener('click', () => {
              const wrapper = button.closest('[data-gift-offer-readmore]');
              const expanded = wrapper.classList.toggle('is-expanded');
              button.setAttribute('aria-expanded', String(expanded));
              button.textContent = expanded ? button.dataset.less : button.dataset.more;
            });
          });
          window.addEventListener('resize', this.updateReadMore);

          this.querySelectorAll('[name="gift_offer_cart"]').forEach((button) => {
            button.addEventListener('click', () => this.openCart());
          });

          // Knoppen elders (bijv. 'Gratis grip toevoegen' in de winkelwagen) openen deze pop-up.
          if (!window.__giftOfferOpenBound) {
            window.__giftOfferOpenBound = true;
            document.addEventListener('click', (event) => {
              const opener = event.target.closest('[data-gift-offer-open]');
              const popup = document.querySelector('gift-offer-popup');
              if (!opener || !popup || popup.hidden) return;
              event.preventDefault();
              popup.open(true);
            });
          }

          document.addEventListener('shopify:section:select', this.handleSectionSelect);

          if (!this.designMode && this.wasSeen()) return;
          if (this.dataset.autoOpen !== 'true') return;
          const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
          this.openTimer = window.setTimeout(() => this.open(), delay);
        }

        disconnectedCallback() {
          window.clearTimeout(this.openTimer);
          window.removeEventListener('resize', this.updateReadMore);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        }

        handleSectionSelect(event) {
          if (event.target && event.target.contains(this)) this.open(true);
        }

        open(force) {
          if (!this.dialog || this.dialog.open || (!force && this.hasOpened)) return;
          this.hasOpened = true;
          this.dialog.showModal();
          this.updateReadMore();
          if (!force) this.markSeen();
        }

        updateReadMore() {
          this.querySelectorAll('[data-gift-offer-readmore]').forEach((wrapper) => {
            const button = wrapper.querySelector('.gift-offer-popup__read-more');
            const inner = wrapper.querySelector('.gift-offer-popup__text-inner');
            if (!button || !inner || wrapper.classList.contains('is-expanded')) return;
            button.hidden = inner.scrollHeight <= inner.clientHeight + 1;
          });
        }

        openCart() {
          this.dialog.close();
          const drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show();
          } else {
            window.location.href = `${window.Shopify.routes.root}cart`;
          }
        }

        // Toevoegen zoals Impact het zelf doet: sections bundelen, cart/add.js, daarna variant:add en cart:change.
        async addItems(items) {
          const sectionsToBundle = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items,
              sections: sectionsToBundle.join(','),
              sections_url: `${window.Shopify.routes.root}variants/${items[items.length - 1].id}`,
            }),
          });
          const responseJson = await response.json();
          if (!response.ok) return { error: responseJson.description || responseJson.message || '' };

          this.dialog.close();
          if (window.themeVariables && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
            window.location.href = `${window.Shopify.routes.root}cart`;
            return {};
          }

          const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
          cart.sections = responseJson.sections;
          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson.items || [responseJson], cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
          return {};
        }

        wasSeen() {
          if (!this.onePerVisit) return false;
          try {
            return window.sessionStorage.getItem(this.dataset.storageKey) === 'seen';
          } catch (exception) {
            return false;
          }
        }

        markSeen() {
          if (!this.onePerVisit || this.designMode) return;
          try {
            window.sessionStorage.setItem(this.dataset.storageKey, 'seen');
          } catch (exception) {
            return;
          }
        }
      }
    );
  }

  if (!customElements.get('gift-offer-bundle')) {
    customElements.define(
      'gift-offer-bundle',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.form = this.querySelector('form');
          this.popup = this.closest('gift-offer-popup');
          this.button = this.form ? this.form.querySelector('[type="submit"]') : null;
          try {
            this.items = JSON.parse(this.querySelector('[data-gift-offer-items]').textContent);
          } catch (exception) {
            this.items = [];
          }
          if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }

        setError(message) {
          const error = this.querySelector('[data-gift-offer-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = !message;
        }

        async onSubmit(event) {
          event.preventDefault();
          if (!this.popup || !this.items.length) return;
          const items = [];
          if (this.dataset.addProduct) items.push({ id: Number(this.dataset.addProduct), quantity: 1 });
          this.items.forEach((item) => items.push(item));

          this.setError('');
          this.button.setAttribute('disabled', '');
          this.button.setAttribute('aria-busy', 'true');
          try {
            const result = await this.popup.addItems(items);
            if (result.error) this.setError(result.error);
          } catch (exception) {
            console.error(exception);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } finally {
            this.button.removeAttribute('disabled');
            this.button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  if (!customElements.get('gift-offer-picker')) {
    customElements.define(
      'gift-offer-picker',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.form = this.querySelector('form');
          this.popup = this.closest('gift-offer-popup');
          this.idInput = this.form.querySelector('input[name="id"]');
          this.button = this.form.querySelector('[type="submit"]');
          this.optionsContainer = this.querySelector('[data-gift-offer-options]');
          const caret = this.querySelector('[data-gift-offer-caret]');
          this.caretHTML = caret ? caret.innerHTML : '';

          try {
            this.products = JSON.parse(this.querySelector('[data-gift-offer-products]').textContent);
          } catch (exception) {
            this.products = [];
          }
          this.product = this.products[Number(this.dataset.initialIndex) || 0];
          if (!this.product) return;

          const swatch = this.querySelector(`[data-gift-offer-swatch][value="${Number(this.dataset.initialIndex) || 0}"]`);
          if (swatch) swatch.checked = true;

          this.form.addEventListener('change', (event) => {
            if (event.target.matches('[data-gift-offer-swatch]')) this.selectProduct(Number(event.target.value));
            else if (event.target.matches('[data-gift-offer-option]')) this.onOptionChange();
          });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
          this.onOptionChange();
        }

        getSelects() {
          return Array.from(this.querySelectorAll('[data-gift-offer-option]'));
        }

        // Ander bolletje = ander product: keuzelijsten opnieuw opbouwen, gekozen waarde zo mogelijk behouden.
        selectProduct(index) {
          const product = this.products[index];
          if (!product) return;
          const previous = {};
          this.getSelects().forEach((select) => {
            previous[select.dataset.optionName] = select.value;
          });

          this.product = product;
          const fallback = product.variants.find((variant) => variant.available) || product.variants[0];
          this.optionsContainer.innerHTML = '';
          product.options.forEach((option) => {
            const id = `${this.dataset.cardId}-${index}-${option.index}`;
            const wrapper = document.createElement('div');
            wrapper.className = 'gift-offer-picker__option';
            const label = document.createElement('label');
            label.className = 'gift-offer-picker__label';
            label.htmlFor = id;
            label.textContent = option.name;
            const selectWrapper = document.createElement('div');
            selectWrapper.className = 'gift-offer-picker__select-wrapper';
            const select = document.createElement('select');
            select.id = id;
            select.className = 'gift-offer-picker__select';
            select.dataset.giftOfferOption = '';
            select.dataset.optionIndex = option.index;
            select.dataset.optionName = option.name;
            option.values.forEach((value) => select.add(new Option(value, value)));
            const keep = previous[option.name];
            select.value = keep && option.values.includes(keep) ? keep : fallback.options[option.index];
            selectWrapper.append(select);
            selectWrapper.insertAdjacentHTML('beforeend', this.caretHTML);
            wrapper.append(label, selectWrapper);
            this.optionsContainer.append(wrapper);
          });
          this.onOptionChange();
        }

        onOptionChange() {
          const selects = this.getSelects();
          this.variant = this.product.variants.find((variant) =>
            selects.every((select) => variant.options[Number(select.dataset.optionIndex)] === select.value)
          );
          this.setError('');
          this.render();
        }

        render() {
          const product = this.product;
          const variant = this.variant;
          this.idInput.value = variant ? variant.id : '';

          this.querySelectorAll('[data-gift-offer-link]').forEach((link) => {
            link.href = product.url;
          });
          const title = this.querySelector('[data-gift-offer-title]');
          if (title) title.textContent = product.title;

          const value = this.querySelector('[data-gift-offer-value]');
          if (value && variant) value.textContent = variant.value;

          const stock = this.querySelector('[data-gift-offer-stock]');
          if (stock) {
            stock.textContent = variant ? variant.stock : this.dataset.textUnavailable;
            stock.dataset.state = variant ? variant.stockState : 'sold-out';
          }

          const image = this.querySelector('.gift-offer-picker__media img');
          const imageSrc = (variant && variant.image) || product.image;
          if (image && imageSrc && image.getAttribute('src') !== imageSrc) {
            image.removeAttribute('srcset');
            image.src = imageSrc;
          }

          if (!this.button) return;
          const available = Boolean(variant && variant.available);
          this.button.disabled = !available;
          if (available) this.setLabel(this.dataset.textAdd);
          else this.setLabel(variant ? this.dataset.textSoldOut : this.dataset.textUnavailable);
        }

        // Impact zet de knoptekst in een <div> naast de laad-animatie; alleen die tekst aanpassen.
        setLabel(label) {
          if (!this.button) return;
          const content = this.button.querySelector(':scope > div') || this.button;
          content.textContent = label;
        }

        setError(message) {
          const error = this.querySelector('[data-gift-offer-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = !message;
        }

        async onSubmit(event) {
          event.preventDefault();
          if (!this.popup || !this.variant || !this.variant.available) return;
          const items = [];
          if (this.dataset.addProduct) items.push({ id: Number(this.dataset.addProduct), quantity: 1 });
          items.push({ id: this.variant.id, quantity: 1 });

          this.setError('');
          this.button.setAttribute('disabled', '');
          this.button.setAttribute('aria-busy', 'true');
          try {
            const result = await this.popup.addItems(items);
            if (result.error) this.setError(result.error);
          } catch (exception) {
            console.error(exception);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } finally {
            this.button.removeAttribute('disabled');
            this.button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
